<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12"
        ><div class="text-h5 font-weight-black my-2">
          {{ componentData.title }}
        </div>
      </v-col>
      <v-col cols="12" class="py-3">
        <div>
          <v-icon :color="iconSettinn.color" :size="iconSettinn.size">{{
            iconSettinn.name
          }}</v-icon>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="text-body-1">
          {{ componentData.description }}
        </div>
      </v-col>
      <v-col>
        <div class="py-1"></div>
        <v-btn block large color="primary" @click="GoSignInNow()">
          <span class="mx-2 text-capitalize">{{ componentData.goSignIn }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VerifyEmailExpired",
  data() {
    return {
      componentData: {
        title: "連結已失效",
        description: "此連結已逾時失效，請重新操作。",
        goSignIn: "前往登入",
      },
      iconSettinn: {
        name: "mdi-close-circle-outline",
        color: "warning",
        size: "50",
      },
    };
  },
  methods: {
    GoSignInNow() {
      this.$emit("switch", "SignIn");
      this.$router.push({ name: "SignIn" });
    },
  },
};
</script>
